export default __webpack_public_path__ + "static/media/estimating-people-resources.9c2949cc.svg";